<template>
    <div class="business-tax-data-table" style="width: 100%;">
        <component
            ref="Table"
            style="width: calc(100vw - 300px);"
            :is="componentName"
            :helper-mode="helperMode"
            :showPeriod="showPeriod"
            :pagination-height="isQuickDeclareStepSummary ? 0 : 50"
            @open="onOpen"
        />
        <div v-if="!isQuickDeclareStepSummary" class="pagination-wrapper">
            <el-pagination
                layout="prev, pager, next"
                class="pagination"
                :page-size.sync="pageSize"
                :current-page.sync="pageNum"
                :total.sync="totalDataCount"
                :small="isMobile()"
                @current-change="updateData"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import _ from 'lodash';
import PaymentTable from '@/components/dashboard/Accounting/BusinessTax/PaymentTable.vue';
import InvoiceTable from '@/components/dashboard/Accounting/BusinessTax/InvoiceTable.vue';
import DeclaredTable from '@/components/dashboard/Accounting/BusinessTax/DeclaredTable.vue';

export default {
    props: {
        // ======================== DataTableMixins =============================
        helperMode: Boolean,
        showPeriod: {
            type: Boolean,
            default: false,
        },
        activeTab: {
            type: String,
            default: '',
        },
    },
    components: { PaymentTable, InvoiceTable, DeclaredTable },
    computed: {
        ...mapState({
            periodList: (state) => state.businessTax.periodList,
            stateTotalDataCount: (state) => state.businessTax.totalDataCount,
            queryParams: (state) => state.businessTax.queryParams,
            datas: (state) => state.businessTax.datas,
        }),
        pageSize: {
            get() {
                return this.queryParams.PageSize;
            },
            set(val) {
                this.syncPageSize(val);
            },
        },
        pageNum: {
            get() {
                return this.queryParams.PageNum;
            },
            set(val) {
                this.syncPageNum(val);
            },
        },
        totalDataCount: {
            get() {
                return this.stateTotalDataCount;
            },
            set(val) {
                this.syncTotalDataCount(val);
            },
        },
        isQuickDeclareStepSummary() {
            return this.$route.name === 'accounting-business-tax-quick-declare-step-4';
        },
        componentName() {
            if (this.isQuickDeclareStepSummary) return 'DeclaredTable';
            return this.queryParams.QueryType === 1 ? 'InvoiceTable' : 'PaymentTable';
        },
        isChangeCodeBtnShow() {
            return this.$route.query.activeTab === 'undeclared' || (this.$route.query.activeTab === 'declared' && !!this.selectedItems.length);
        },
    },
    watch: {
        selectedItems() {
            this.$emit('toggleLock', !!this.selectedItems.length);
        },
    },
    methods: {
        ...mapMutations({
            syncPageSize: 'businessTax/syncPageSize',
            syncPageNum: 'businessTax/syncPageNum',
            syncTotalDataCount: 'businessTax/syncTotalDataCount',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
        }),
        onSortChange(event) {
            if (event.prop !== 'declared') return;

            if (!event.order) {
                this.fetchData();
                return;
            }

            const invoiceResult = _.sortBy(this.datas.invoiceResult, 'declared');
            const paymentResult = _.sortBy(this.datas.paymentResult, 'declared');

            if (event.order === 'ascending') {
                this.datas = {
                    invoiceResult: invoiceResult.reverse(),
                    paymentResult: paymentResult.reverse(),
                };
            } else this.datas = { invoiceResult, paymentResult };
        },
        onOpen(sno, typ, isTranInovice) {
            if (isTranInovice) {
                this.$emit('onOpenTranInvoiceDetail', sno);
                return;
            }

            const isIncome = typ ? typ === 1 : this.queryParams.QueryType === 1;
            this.$emit(isIncome ? 'onOpenInvoiceDetail' : 'onOpenPaymentDetail', sno);
        },
    },
};
</script>

<style lang="scss">
.business-tax-data-table {
    .pagination-wrapper {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
